import React from 'react'
import Navbar from "./Navbar"
import userData from '../userData'
import Footer from './Footer'
import ButtonMailto from './MailTo'
import "../css/contact.css"


function Contact() {
    return (
        <div>
            <Navbar
                userImg={userData[0].userImg}
            />
            <div className="cat-div">
                <div class="cat-helpMe"></div>
                <span className="span-help-center">
                    <h3 className="contact-us" >Contact Us</h3>
                    <br />
                    <h2 className="question" >Questions or Feedbacks?<br />Get In Touch.</h2></span>

            </div>
            <div className="contctUs">
                <h3 className="loveTo">We would love to hear from you.</h3>

                <div className="row contactUs-row">
                    <div className="contactUs-box col-lg-4 col-md-6">
                        <i className="contact-icon fa-solid fa-location-dot"></i>
                        <p className="contactUs-at">Our main office</p>
                        <p className="contactUs-info">777 Hues Branch, Sector XX, Gurugram, <br />Haryana 1220XX</p>
                    </div>
                    <div className="contactUs-box col-lg-4 col-md-6">
                        <i class="contact-icon fa-regular fa-phone"></i>
                        <p className="contactUs-at">Call us</p>
                        <p className="contactUs-info">
                            98XXXXXXXX
                            <br />
                            97XXXXXXXX0
                        </p>
                    </div>
                    <div className="contactUs-box col-lg-4 col-md-6">
                        <i class="contact-icon fa-regular fa-envelope"></i>
                        <p className="contactUs-at">Email us</p>
                        <p className="contactUs-info" >
                            <ButtonMailto className="petMe-email" label="teampetme@gmail.com" mailto="teampetme@gmail.com"></ButtonMailto>
                        </p>

                    </div>
                </div>

                <h3 className="followUs">Follow us for more on</h3>
                <div className="row social-media-row">
                    <div className="handke-box ">
                        <i class="handle-icon fa-brands fa-twitter"></i>
                    </div>
                    <div className="handle-box ">
                        <i class="handle-icon fa-brands fa-instagram"></i>
                    </div>
                    <div className="handle-box ">
                        <i class="handle-icon fa-brands fa-facebook"></i>
                    </div>
                </div>

            </div>
            <Footer />

        </div>
    )
}

export default Contact